import { render } from "./ArchiveSwitch.vue?vue&type=template&id=70a0506f&scoped=true"
import script from "./ArchiveSwitch.vue?vue&type=script&lang=js"
export * from "./ArchiveSwitch.vue?vue&type=script&lang=js"

import "./ArchiveSwitch.vue?vue&type=style&index=0&id=70a0506f&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a0506f"]])

export default __exports__